export const SELECT_LIGHTBOX_IMAGE = 'SELECT_LIGHTBOX_IMAGE'
export const SET_TENANT_ID_FOR_UPGRADE = 'SET_TENANT_ID_FOR_UPGRADE'
export const OPEN_UPGRADE_MODAL = 'OPEN_UPGRADE_MODAL'
export const RETRIEVE_CRM_FORM = 'RETRIEVE_CRM_FORM'
export const FORM_SUBMIT = 'FORM_SUBMIT'
export const PRESELECT_QUOTE_OPTION = 'PRESELECT_QUOTE_OPTION'

export const selectLightboxImage = img => dispatch => {
  return dispatch({ type: SELECT_LIGHTBOX_IMAGE, img })
}

export const clearLightboxImage = () => dispatch => {
  return dispatch({ type: SELECT_LIGHTBOX_IMAGE, img: null })
}

export const setTenantId = tenantId => dispatch => {
  return dispatch({ type: SET_TENANT_ID_FOR_UPGRADE, tenantId })
}

export const openUpgradeModal = modalId => dispatch => {
  return dispatch({ type: OPEN_UPGRADE_MODAL, modalId })
}

export const isAnyPartOfElementInViewport = el => {
  const rect = el.getBoundingClientRect()
  const windowHeight = window.innerHeight || document.documentElement.clientHeight
  const inViewOrBefore = rect.top <= windowHeight - windowHeight * 0.3

  console.log(inViewOrBefore, el, windowHeight, rect)

  return inViewOrBefore
}

export const preselectOption = (fieldName, value) => dispatch => {
  return Promise.resolve(dispatch({ type: PRESELECT_QUOTE_OPTION, fieldName, value }))
}
